module.exports = __webpack_public_path__ + "static/media/Chief Wiggum.6bc42347.png";